<template>
  <div class="add">
    <div class="addHead el-row--flex">
      <el-button size="mini" @click="add">
        <i class="el-icon-plus"></i>
        创建委托(印章授权)协议
      </el-button>
    </div>
    <el-form :inline="true" size="mini" :model="filter" class="demo-form-inline">
      <el-form-item label="委托人">
        <el-input v-model="filter.signFirstName"></el-input>
      </el-form-item>
      <el-form-item label="受托人">
        <el-input v-model="filter.signSecondName"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      height="718"
      size="mini"
      :border="true">
      <el-table-column
        label="序号"
        type="index"
        min-width="64">
      </el-table-column>
      <!-- <el-table-column
        label="文件">
        <template slot-scope="scope">
          <span @click="openWin(scope.row.contractUrl)" style="color: #1875f0;">预览</span>
        </template>
      </el-table-column> -->
      <el-table-column
        width="100px"
        label="协议状态">
        <template slot-scope="scope">
          {{ $global.signStatusStr(scope.row.signStatus) }}
        </template>
      </el-table-column>
      <el-table-column
        width="180px"
        label="协议编号">
        <template slot-scope="scope">
          {{ scope.row.contractNum }}
        </template>
      </el-table-column>
      <el-table-column
        min-width="200"
        label="委托人">
        <template slot-scope="scope">
          {{ scope.row.signFirstName }}
        </template>
      </el-table-column>
      <el-table-column
        width="200px"
        label="受托人">
        <template slot-scope="scope">
          {{ scope.row.signSecondName }}
        </template>
      </el-table-column>
      <el-table-column
        width="100px"
        label="签订日期">
        <template slot-scope="scope">
          {{ scope.row.contractDate }}
        </template>
      </el-table-column>
      <el-table-column
        width="100px"
        label="生效日期">
        <template slot-scope="scope">
          {{ scope.row.startDate }}
        </template>
      </el-table-column>
      <el-table-column
        width="100px"
        label="失效日期">
        <template slot-scope="scope">
          {{ scope.row.endDate }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        fixed="right"
        width="280px"
        label="操作">
        <template slot-scope="scope">
          <el-button v-if="scope.row.signStatus != 5" type="primary" :disabled="scope.row.countSecond != 0" size="mini" @click="msg(scope.row.contractId, 1)">委托人短信{{ scope.row.countSecond == 0 ? '' : scope.row.countSecond }}</el-button>
          <el-button v-if="scope.row.signStatus != 5" type="primary" size="mini" @click="msg(scope.row.contractId, 2)">受托人短信</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableData.length"
      @current-change="pageChange"
      @size-change="handleSizeChange"
    ></el-pagination>
    <el-dialog
      title="创建委托(印章授权)协议"
      :visible.sync="addShow"
      width="900px"
      :before-close="addClose">
      <el-form :model="addParam" size="mini" :rules="addRule" ref="add" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="委托人" prop="signFirstId">
              <el-select
                v-model="addParam.signFirstId"
                filterable
                remote
                placeholder="请查询委托人"
                @change="firstChange"
                :remote-method="searchFirst"
                :loading="searchloading">
                <el-option
                  v-for="item in firstList"
                  :key="item.contractUserId"
                  :label="item.userName"
                  :value="item.contractUserId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            PS：签署授权人，如企业法人(企业名称)
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="受托人" prop="signSecondId">
              <el-select
                v-model="addParam.signSecondId"
                filterable
                remote
                placeholder="请查询受托人"
                @change="secondChange"
                :remote-method="searchSecond"
                :loading="searchloading">
                <el-option
                  v-for="item in secondList"
                  :key="item.contractUserId"
                  :label="item.userName"
                  :value="item.contractUserId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            PS：被授权操作人，如经办人(企业名称)
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="生效日期" prop="startDate">
              <el-date-picker
                v-model="addParam.startDate"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="失效日期" prop="endDate">
              <el-date-picker
                v-model="addParam.endDate"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            委托人（企业法人）与受托人签署委托协议之后，发送给该企业的合同将经由受托人完成签署。委托协议内容模板详见：
            <span @click="openWin('/weituoshu-01.pdf')" style="color: #1875f0;">查看模板</span>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addShow = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        addShow: false,
        searchloading: false,
        firstList: [],
        secondList: [],
        addParam: {
          signFirstId: '',
          signFirstName: '',
          signSecondId: '',
          signSecondName: '',
          startDate: new Date(),
          endDate: new Date().setFullYear(new Date().getFullYear() + 1)
        },
        addRule: {
          signFirstId: [
            { required: true, message: '委托人不能为空', trigger: 'change' }
          ],
          signSecondId: [
            { required: true, message: '受托人不能为空', trigger: 'change' }
          ],
          startDate: [
            { required: true, message: '生效日期不能为空', trigger: 'change' },
          ],
          endDate: [
            { required: true, message: '失效日期不能为空', trigger: 'change' }
          ]
        },
        currentPage: 1,
        pageSize: '10',
        filter: {
          signFirstName: '',
          signSecondName: ''
        },
        tableData: [],
        countArr: []
      }
    },
    mounted() {
      this.refresh();
    },
    methods: {
      add() {
        this.addShow = true;
      },
      addClose() {
        this.addShow = false;
      },
      save() {
        this.$refs['add'].validate(valid => {
          if (valid) {
            let data = new Object();
            for (let key in this.addParam) {
              if (key.indexOf('Date') !== -1) {
                data[key] = this.$global.format(this.addParam[key], 'yyyy-MM-dd');
              } else {
                data[key] = this.addParam[key];
              }
            }
            data.contractType = 2;
            this.$global.axios.post(this, '/sywl/api/eqb/contractInfo/authorize', {
              jsonStr: JSON.stringify(data)
            }, res1 => {
              this.$message.success('添加成功');
              location.reload();
            })
          }
        })
      },
      searchFirst(keyword) {
        this.searchId(keyword, 'first');
      },
      searchSecond(keyword) {
        this.searchId(keyword, 'second');
      },
      searchId(keyword, type) {
        this.searchloading = true;
        this.$global.axios.post(this, type == 'first' ? '/sywl/api/contractUser/getContractUserList' : '/sywl/api/contractUser/getContractUserList', {
          keyword: keyword
        }, res => {
          this.searchloading = false;
          this[type+'List'] = res.data;
        })
      },
      firstChange(e) {
        this.firstList.forEach(ele => {
          if (ele.contractUserId == e) {
            this.addParam.signFirstName = ele.userName;
          }
        })
      },
      secondChange(e) {
        this.secondList.forEach(ele => {
          if (ele.contractUserId == e) {
            this.addParam.signSecondName = ele.userName;
          }
        })
      },
      refresh() {
        let data = this.filter;
        data.contractType = 2;
        data.pageNo = this.currentPage;
        data.pageSize = this.pageSize;
        this.$global.axios.post(this, '/sywl/api/contractInfo/list', data, res => {
          res.data.records.forEach(ele => {
            ele.countSecond = 0;
          })
          this.tableData = res.data.records;
        })
      },
      pageChange(t) {
        this.currentPage = t;
        this.refresh();
      },
       handleSizeChange(n) {
        this.pageSize= n;
        this.refresh();
      },
      onSubmit() {
        this.currentPage = 1;
        this.refresh();
      },
      msg(id, type) {
        this.$global.axios.post(this, '/sywl/api/contractInfo/sendMess', {
          contractId: id,
          signSquare: type
        }, res => {
          this.$message.success('发送成功');
        }, res => {}, res => {
          let tableIndex;
          this.tableData.forEach((ele, index) => {
            if (id == ele.contractId) {
              tableIndex = index;
            }
          })
          const ind = this.countArr.length;
          this.tableData[tableIndex].countSecond = 60;
          const that = this;
          this.countArr[ind] = setInterval(() => {
            that.tableData[tableIndex].countSecond--;
            if (that.tableData[tableIndex].countSecond == 0) clearInterval(that.countArr[ind]);
          }, 1000)
        })
      },
      openWin(url) {
        window.open(url, null, 'width=1200px,height=700px,scrollbars=yes');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .add {
    padding: 12px 16px;
    background-color: #fff;

    & /deep/ .el-dialog__header {
      background-color: #000;
      text-align: left;
      color: #fff;

      .el-dialog__title {
        color: #fff;
      }
    }

    & /deep/ .el-dialog__body {
      padding: 20px;

      .el-form {
        text-align: left;

        .el-select {
          width: calc(100% - 13px);
        }

        .el-date-editor--date {
          display: inline-block;
          width: calc(100% - 13px);
        }
      }
    }

    &Head {
      .el-button {
        margin-bottom: 20px;
        border-color: #1875f0;
        color: #1875f0;
      }
    }

    .el-form {
      text-align: left;
    }

    & /deep/ .el-table {
      .el-table__cell {
        font-size: 12px;
        text-align: center;
      }
    }

    .el-pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/service/commission.vue